export default {
    list: {
        loadingText: 'Loading...',
        noMoreText: 'No more content',
        emptyText: 'No content',
        loadMoreText: 'More',
    },
    modal: {
        cancelText: 'Cancel',
        okText: 'Confirm',
    },
    selectAngle: {
        title: 'Angle',
    },
};
